/*
 * Views for the List region of the substitutions page
 */

define([
  "marionette",
  "modules/reportSplit/groups/groupList/template/groupListTemplate.html",
  "modules/reportSplit/groups/groupList/template/groupItemTemplate.html",
], function (Marionette, GroupListTemplate, GroupItemTemplate) {
  var GroupView = {};

  GroupView.groupItem = Marionette.ItemView.extend({
    template: GroupItemTemplate,
    tagName: "li",
    triggers: {
      click: "click:reportGroup",
    },
  });

  GroupView.reportList = Marionette.CompositeView.extend({
    template: GroupListTemplate,
    itemViewContainer: "ul",
    itemView: GroupView.groupItem,
    collectionEvents: {
      sort: "render",
    },
  });

  return GroupView;
});
